import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface AccessoryBullet {
  free: boolean;
  name: string;
  note: string;
}

interface Props {
  bullets: AccessoryBullet[];
}

const AccessoryBulletList: FC<Props> = ({ bullets }) => {
  return (
    <Box component="ul" sx={{ pl: '20px', m: 0 }}>
      {bullets.map((bullet, index) => (
        <Box component="li" key={`${bullet.name}-${index}`} sx={{ mb: '4px' }}>
          <Typography component="span" sx={{ fontSize: '14px' }}>
            {bullet.free && (
              <Typography
                component="span"
                sx={{
                  color: 'promo.bulletFree',
                  fontWeight: 700,
                  fontSize: 'inherit',
                }}
              >
                FREE{' '}
              </Typography>
            )}
            <Typography
              component="span"
              sx={{ color: 'promo.bulletName', fontSize: 'inherit' }}
            >
              {bullet.name}
            </Typography>
            {bullet.note && (
              <Typography
                component="span"
                sx={{ color: 'grey.600', fontSize: 'inherit', ml: '4px' }}
              >
                {bullet.note}
              </Typography>
            )}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default AccessoryBulletList;
